<div class="datepicker-container">
    <span [hidden]="!closeOption" class="close" title="Close" (click)="close.emit($event)">X</span>
  <div class="datepicker" [ngClass]="">
    <dp-day-calendar
    [(ngModel)]="selectedDate"
    (onSelect)="onSelect($event)"
    [theme]="theme"
    [displayDate]="displayDate"
    [config]="config"
    ></dp-day-calendar>
  </div>
</div>
